import React from 'react';
import styled, { StylesProps } from '../../../lib/styles';
import authorPanelStyles from './AuthorBlock_styles';
import { Author } from '../../../models/article';
import Spacer from '../../../components/presentational/Spacer';
import StoryAuthor from '../../../components/presentational/StoryAuthor';

export interface AuthorBlockProps {
  author: Author;
  heading: boolean;
}

const AuthorBlock = ({
  author,
  styles,
  heading,
}: AuthorBlockProps & StylesProps<typeof authorPanelStyles>) => (
  <div className={styles.container}>
    <Spacer width={1160} space={'m'} align={'flex-start'}>
      <StoryAuthor heading={heading} size={'xl'} author={author} tagline />
    </Spacer>
  </div>
);

export default styled(authorPanelStyles)(AuthorBlock);
